<template>
    <div :class="['section-title', { dark: theme == THEMES.DARK }]">
        <slot />
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    props: {},
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.section-title {
    font-size: 1.4em;
    margin: 10px 0;
    font-weight: 700;
    color: $textColor;
    &.dark {
        color: $darkTextColor;
    }
}
</style>
